import type { PortraitFilterOption } from '../types/portrait-filter-option'

/**
 * Tells options that share a name apart. Custom group (and homeroom) names are not unique, and a
 * dropdown row shows only its name, so two rows would look the same. Only repeated names change:
 * each gets its place in the list ("Chess Team (2 of 3)"); a name that appears once is untouched.
 */
export function disambiguateDuplicateLabels(
  options: PortraitFilterOption[]
): PortraitFilterOption[] {
  const totals = new Map<string, number>()

  for (const { label } of options) {
    totals.set(label, (totals.get(label) ?? 0) + 1)
  }

  const seen = new Map<string, number>()

  return options.map((option) => {
    const total = totals.get(option.label) ?? 1

    if (total === 1) {
      return option
    }

    const position = (seen.get(option.label) ?? 0) + 1

    seen.set(option.label, position)

    return { ...option, label: `${option.label} (${position} of ${total})` }
  })
}
